import { createSelector } from 'reselect'
import { isEmpty, groupBy } from 'lodash-es'
import { DateTime } from 'luxon'

const formatDate = (date) =>
  DateTime.fromSQL(date).toISO({ suppressMilliseconds: true }) ?? ''

const formatComments = (comments) => {
  if (isEmpty(comments)) {
    return []
  }

  return comments.toArray().map((comment) => {
    const date = comment.creation_date_ansi || comment.entry_date_ansi

    return { ...comment, dateFormatted: formatDate(date) }
  })
}

export default ({ getFeatureRoot }) => {
  const getChatComments = (state) => getFeatureRoot(state).chat.comments
  const getQuestionComments = (state) =>
    getFeatureRoot(state).questions.comments

  const getQuestions = createSelector([getQuestionComments], (questions) =>
    formatComments(questions)
  )

  const getChatMessages = createSelector([getChatComments], (messages) =>
    formatComments(messages)
  )

  const getQuestionGroupedByStatus = createSelector(
    getQuestionComments,
    (questions) => {
      const groupedComments = groupBy(questions.toArray(), 'comment_status')
      return groupedComments
    }
  )

  return {
    getQuestions,
    getChatMessages,
    getQuestionGroupedByStatus,
  }
}
